/* VANA Sticky-Kaufleiste – ausgelagert 12.10.2026 aus snippets/vana-sticky-atc.liquid
   13.10.2026: Vorbestellung (Timesact) wird gespiegelt – Button heißt dann "Jetzt vorbestellen" */
(function () {
  if (window.__vanaStickyAtcBooted) return;
  window.__vanaStickyAtcBooted = true;

  function init() {
    var bar = document.querySelector('[data-vana-satc]');
    if (!bar) return;
    var mainForm = document.querySelector(
      'product-form [data-product-form], [data-product-form-wrapper] [data-product-form]',
    );
    var mainBtn = mainForm ? mainForm.querySelector('[data-add-to-cart]') : null;
    if (!mainForm || !mainBtn) return;

    var addBtn = bar.querySelector('[data-vana-satc-add]');
    var priceEl = bar.querySelector('[data-vana-satc-price]');
    var btnText = bar.querySelector('[data-vana-satc-btn-text]');
    var selects = Array.prototype.slice.call(bar.querySelectorAll('[data-vana-satc-option]'));
    var visible = false;

    function radiosFor(optionName) {
      return Array.prototype.slice.call(
        document.querySelectorAll('input[type="radio"][name="options[' + optionName + ']"]'),
      );
    }

    // Auswahl in der Leiste -> echte Variantenauswahl im Hauptformular
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var radios = radiosFor(sel.getAttribute('data-vana-satc-option'));
        var target = radios.filter(function (r) {
          return r.value === sel.value;
        })[0];
        if (target && !target.checked) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Hauptformular -> Leiste (Preis, Verfügbarkeit, gewählte Option, Vorbestellung)
    function syncFromMain(variant) {
      selects.forEach(function (sel) {
        var checked = radiosFor(sel.getAttribute('data-vana-satc-option')).filter(function (r) {
          return r.checked;
        })[0];
        if (checked && sel.value !== checked.value) sel.value = checked.value;
      });
      var mainPrice = mainBtn.querySelector('[data-button-price]');
      if (priceEl && mainPrice) priceEl.textContent = mainPrice.textContent.trim();
      var mainLabel = (mainBtn.textContent || '').replace(/\s+/g, ' ').trim();
      var isPreorder = /vorbestell/i.test(mainLabel);
      var soldOut = variant && typeof variant.available === 'boolean' ? !variant.available : mainBtn.disabled;
      if (isPreorder) soldOut = false;
      addBtn.disabled = !!soldOut;
      bar.classList.toggle('is-preorder', isPreorder);
      if (btnText) {
        var textEl = mainBtn.querySelector('[data-add-to-cart-text]');
        btnText.textContent = soldOut
          ? 'Ausverkauft'
          : isPreorder
            ? 'Jetzt vorbestellen'
            : textEl && textEl.textContent.trim()
              ? textEl.textContent.trim()
              : 'In den Warenkorb';
      }
    }
    var syncTimer = null;
    function scheduleSync() {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () { syncFromMain(); }, 60);
    }
    document.addEventListener('theme:variant:change', function (e) {
      syncFromMain(e.detail && e.detail.variant);
      setTimeout(syncFromMain, 400); // Timesact schreibt den Button-Text etwas später um
    });
    mainForm.addEventListener('change', function () {
      setTimeout(syncFromMain, 0);
    });
    // Apps (z. B. Timesact Pre-Order) ändern Text/Zustand des Haupt-Buttons direkt im DOM
    new MutationObserver(scheduleSync).observe(mainBtn, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'class'],
    });
    syncFromMain();
    setTimeout(syncFromMain, 800);

    // Klick -> echter Theme-Button (Cart-Drawer, Upsell, Vorbestell-Popup usw. laufen wie gewohnt)
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      mainBtn.click();
      setTimeout(function () {
        addBtn.classList.remove('is-loading');
      }, 1500);
    });

    // Sichtbarkeit: zeigen, wenn der Haupt-Button nach oben aus dem Bild gescrollt ist
    function show(on) {
      if (on === visible) return;
      visible = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.toggleAttribute('data-vana-satc-on', on);
    }
    bar.hidden = false;
    // Leiste zeigen, sobald der Haupt-Button nicht im Bild ist (egal ob darüber oder darunter)
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          // 16.10.2026: erst zeigen, wenn der Haupt-Button nach OBEN aus dem Bild gescrollt ist
          // (vorher sieht die Kundin Bild, Titel, Vorteile und Preis ohne zweiten Kaufen-Button)
          var e = entries[0];
          show(!e.isIntersecting && e.boundingClientRect.top < 0);
        },
        { threshold: 0 },
      ).observe(mainBtn);
    } else {
      var check = function () {
        var r = mainBtn.getBoundingClientRect();
        show(r.bottom < 0);
      };
      window.addEventListener('scroll', check, { passive: true });
      check();
    }

    // Ausblenden, solange ein Drawer/Modal offen ist (Pipeline setzt Scroll-Lock auf <body>)
    new MutationObserver(function () {
      var locked = document.body.getAttribute('data-scroll-lock-locked') === 'true';
      document.documentElement.toggleAttribute('data-vana-satc-hidden', locked);
    }).observe(document.body, { attributes: true, attributeFilter: ['data-scroll-lock-locked'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
